import { Button } from "@/components/ui/button";
import { Timer, LogOut } from "lucide-react";
import { useAuth } from "@/lib/auth";

export function IdleTimeoutWarning({ secondsLeft, onStayLoggedIn }) {
  const { logout } = useAuth();

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 backdrop-blur-sm animate-fade-in" data-testid="idle-timeout-warning">
      <div className="bg-slate-900 border border-slate-700 rounded-xl shadow-2xl max-w-sm w-full mx-4 overflow-hidden">
        {/* Progress bar */}
        <div className="h-1 bg-slate-800">
          <div
            className="h-full bg-amber-500 transition-all duration-1000 ease-linear"
            style={{ width: `${Math.max(0, (secondsLeft / 60) * 100)}%` }}
          />
        </div>

        <div className="p-6 text-center space-y-4">
          {/* Icon */}
          <div className="w-14 h-14 rounded-full bg-amber-500/10 border border-amber-500/20 flex items-center justify-center mx-auto">
            <Timer className="w-7 h-7 text-amber-400" />
          </div>

          {/* Text */}
          <div>
            <h3 className="text-lg font-semibold text-white" data-testid="idle-timeout-title">Session Timeout</h3>
            <p className="text-sm text-slate-400 mt-1">
              You've been inactive. Your session will end in
            </p>
            <p className="text-3xl font-mono font-bold text-amber-400 mt-2" data-testid="idle-countdown">
              {secondsLeft}s
            </p>
          </div>

          {/* Actions */}
          <div className="flex gap-3">
            <Button
              variant="outline"
              onClick={logout}
              className="flex-1 border-slate-700 text-slate-300 hover:bg-slate-800 h-11"
              data-testid="idle-logout-btn"
            >
              <LogOut className="w-4 h-4 mr-2" />
              Log Out
            </Button>
            <Button
              onClick={onStayLoggedIn}
              className="flex-1 bg-blue-600 hover:bg-blue-500 text-white h-11 font-semibold"
              data-testid="idle-stay-btn"
            >
              Stay Logged In
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
